import { render, staticRenderFns } from "./dialogos.vue?vue&type=template&id=cb4b1da0&scoped=true&"
import script from "./dialogos.vue?vue&type=script&lang=js&"
export * from "./dialogos.vue?vue&type=script&lang=js&"
import style0 from "./dialogos.vue?vue&type=style&index=0&id=cb4b1da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4b1da0",
  null
  
)

export default component.exports